import React from "react"

import type { ReducedImage } from "types/cms"
import { ShareIcon, Facebook, Twitter, Pinterest } from "components/SVG"

import { color } from "lib/theme/theme.css"
import { Toggleable } from "packages/ui-shared/components/Toggleable/Toggleable"
import { SocialShareLink } from "./SocialShareLink"
import {
  container,
  iconsContainer,
  icon,
  circle,
  bottomCircle,
} from "./PostShare.css"

type Props = {
  title: string
  slug: string
  image: ReducedImage
  testCheck?: boolean
}

export const PostShare: React.FC<Props> = ({
  title,
  slug,
  image,
  testCheck,
}) => (
  <div className={container}>
    <Toggleable
      triggerItem={
        <div className={circle}>
          <ShareIcon fill={color.backgroundInverse} className={icon} />
        </div>
      }
      contentItem={
        <>
          <div className={iconsContainer}>
            <SocialShareLink slug={slug} network="facebook">
              <Facebook fill={color.backgroundInverse} className={icon} />
            </SocialShareLink>
            <SocialShareLink slug={slug} network="twitter">
              <Twitter fill={color.backgroundInverse} className={icon} />
            </SocialShareLink>
            <SocialShareLink
              slug={slug}
              network="pinterest"
              image={image.src}
              title={title}
            >
              <Pinterest fill={color.backgroundInverse} className={icon} />
            </SocialShareLink>
          </div>
          <div className={bottomCircle} />
        </>
      }
      defaultValue={testCheck ? "item-1" : undefined}
    />
  </div>
)
